module.exports = __webpack_public_path__ + "static/media/M.cc4bcc94.jpg";